"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "villafranca-in-lunigiana": {
    "c45b00ad": [{
      "hkey": "2b5506e8",
      "slug": "malgrate-piano-di-malgrate",
      "name": "Malgrate-Piano di Malgrate",
      "primary": true,
      "skipSearch": false
    }],
    "malgrate": [{
      "hkey": "2b5506e8",
      "slug": "malgrate-piano-di-malgrate",
      "name": "Malgrate-Piano di Malgrate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;